/**
 * Testi italiani della Cronologia unica (ADR 0030 §3, tappa 8): filtri,
 * tabella, dettaglio, esportazione e stampa.
 */

/** Testi della Cronologia. */
export const history = {
  /** Titolo. */
  title: 'Cronologia',
  /** Che cosa mostra. */
  description: 'Richieste, risposte, azioni degli agenti e conversazioni di voce di tutti i tuoi set.',

  /** Filtri. */
  filters: {
    /** Nome accessibile del gruppo. */
    label: 'Filtri della cronologia',
    /** Set. */
    set: 'Set',
    /** Tutti i set. */
    allSets: 'Tutti i set',
    /** Progetto. */
    project: 'Progetto',
    /** Tutti i progetti. */
    allProjects: 'Tutti i progetti',
    /** Progetto senza set scelto. */
    pickSetFirst: 'Scegli prima un set',
    /** Tipo. */
    kind: 'Tipo',
    /** Tutti i tipi. */
    allKinds: 'Tutti i tipi',
    /** Stato. */
    status: 'Stato',
    /** Tutti gli stati. */
    allStatuses: 'Tutti gli stati',
    /** Periodo. */
    period: 'Periodo',
    /** Inizio del periodo. */
    from: 'Dal giorno',
    /** Fine del periodo. */
    to: 'Al giorno',
    /** Testo. */
    text: 'Testo',
    /** Segnaposto del testo. */
    textPlaceholder: 'Cerca nel testo',
    /** Togli i filtri. */
    clear: 'Togli i filtri',
  },

  /** Tipi. */
  kinds: {
    /** Richiesta. */
    request: 'Richiesta',
    /** Risposta. */
    response: 'Risposta',
    /** Azione. */
    action: 'Azione',
    /** Voce. */
    voice: 'Voce',
  },

  /** Stati. */
  statuses: {
    /** In coda. */
    queued: 'In coda',
    /** In corso. */
    running: 'In corso',
    /** Conclusa. */
    done: 'Conclusa',
    /** Non riuscita. */
    failed: 'Non riuscita',
    /** Annullata. */
    cancelled: 'Annullata',
    /** Conversazione aperta. */
    active: 'Aperta',
    /** Conversazione chiusa. */
    ended: 'Chiusa',
  },

  /** Tabella. */
  table: {
    /** Nome accessibile. */
    label: 'Voci della cronologia',
    /** Data. */
    date: 'Data',
    /** Set. */
    set: 'Set',
    /** Progetto. */
    project: 'Progetto',
    /** Tipo. */
    kind: 'Tipo',
    /** Stato. */
    status: 'Stato',
    /** Autore. */
    actor: 'Autore',
    /** Testo. */
    text: 'Testo',
    /** Totale delle voci. */
    total_one: '{{count}} voce',
    /** Totale delle voci. */
    total_other: '{{count}} voci',
    /** Pulsante della riga. */
    open: 'Dettaglio',
    /** Nome accessibile del pulsante della riga. */
    openNamed: 'Dettaglio della voce del {{date}}',
    /** Nessuna voce. */
    empty: 'Nessuna voce con questi filtri.',
    /** Lettura non riuscita. */
    loadFailed: 'Cronologia non disponibile. Riprova.',
  },

  /** Dettaglio. */
  detail: {
    /** Titolo. */
    title: 'Dettaglio della voce',
    /** Conclusione. */
    completed: 'Conclusione',
    /** Identificativo. */
    id: 'Identificativo',
    /** Apri nel relay. */
    openRelay: 'Apri nella conversazione',
    /** Nota sul testo accorciato. */
    shortened: 'Il testo è accorciato a 300 caratteri. Il messaggio completo è nella conversazione con l’Institore.',
  },

  /** Azioni della pagina. */
  actions: {
    /** Esportazione. */
    export: 'Esporta CSV',
    /** Esportazione non riuscita. */
    exportFailed: 'Esportazione non riuscita. Riprova.',
    /** Stampa. */
    print: 'Stampa',
  },
};

/** Forma dei testi della Cronologia, usata per tipare le altre lingue. */
export type History = typeof history;
